// extracted by mini-css-extract-plugin
export var logo = "style-module--logo--ejPsI";
export var logoWrapper = "style-module--logoWrapper--AWivk";
export var mainWrapper = "style-module--mainWrapper--CUHBt";
export var primaryText = "style-module--primaryText--5pm8A";
export var subText = "style-module--subText--5-lfp";
export var textWrapper = "style-module--textWrapper--TjZoC";